import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CNameConfiguration } from '@models/email/emailDomain';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailCampaignDnsService } from '@services/email-campaign-dns.service';

@Component({
  selector: 'wsb-email-dns-verify-congig-modal',
  templateUrl: './email-dns-verify-config-modal.component.html',
  styleUrls: ['./email-dns-verify-config-modal.component.scss'],
  standalone: false
})
export class EmailDnsVerifyConfigModalComponent implements OnInit {
  @Input() public title;
  @Input() public idDomain: number;
  @Input() public labelCancelButton = 'common_cancel';
  @Input() public cNameConfigByAddNewDomain: CNameConfiguration = null;

  @Output() cancelEvent: EventEmitter<any> = new EventEmitter();

  cNameConfiguraion: CNameConfiguration;

  constructor(private emailDnsService: EmailCampaignDnsService, public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    // View configuration button
    if (this.cNameConfigByAddNewDomain === null) {
      this.callApiGetDomain(this.idDomain);
    } else {
      // View Add New Domain button
      this.cNameConfiguraion = this.cNameConfigByAddNewDomain;
    }
  }

  private callApiGetDomain(idDomain: number) {
    this.emailDnsService.getDnsCampaign(idDomain).subscribe(data => {
      this.cNameConfiguraion = data;
    });
  }
}
